import {
  DialogHeading,
  DialogBody,
} from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "components.entry_modal.glucose.value_warning."

export function GlucoseValueWarning() {
  const polyglot = usePolyglot()

  return (
    <>
      <DialogHeading>
        {polyglot.t(`${polyglotPrefix}dialog_heading`)}
      </DialogHeading>
      <DialogBody>
        <div>
          {polyglot.t(`${polyglotPrefix}dialog_body1`)}
        </div>
        <div>
          {polyglot.t(`${polyglotPrefix}dialog_body2`)}
        </div>
      </DialogBody>
    </>
  )
}
